// @flow

import { Loading } from '@shopify/app-bridge/actions';
import { getSABAppInstance_Normal, isByPassScript } from './app';

let SABLoadingInstance = null;

function createSABLoadingInstance() {
  const app = getSABAppInstance_Normal();
  SABLoadingInstance = Loading.create(app);
}

export function startSABLoading() {
  if (isByPassScript()) {
    if (!SABLoadingInstance) {
      createSABLoadingInstance();
    }
    SABLoadingInstance.dispatch(Loading.Action.START);
    return
  }

  if (window.shopify?.loading) {
    window.shopify.loading(true)
  }
}

export function stopSABLoading() {
  if (isByPassScript()) {
    if (!SABLoadingInstance) {
      createSABLoadingInstance();
    }
    SABLoadingInstance.dispatch(Loading.Action.STOP);
    return
  }

  if (window.shopify?.loading) {
    window.shopify.loading(false)
  }
}
